import client from './client'

export default {
  getLink(baseUrl,property,booking,amount) {
    return client.get(`${baseUrl}/checkin/api/paymentLink?propertyId=${property}&bookingId=${booking}&amount=${amount}`)
  }
}
